module.exports = __webpack_public_path__ + "img/spain.7009077f.png";